import React from "react";
import { registerWindowEvent } from "../Helpers/windowEvent";
import { Initialization } from "../initial";

export const  Initialize = (props)=>{
    const { initial = {},
    //  initial: { theme = "" } = {}  
    } = props;
    React.useEffect(()=>{
        async function webSocket() {
             Initialization(initial)
          }
          webSocket()
    },[])
    React.useMemo(() => {
        registerWindowEvent()
      }, []);  

    return<></>
   }


